import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PageHero from "../components/child/PageHero";
import APIAccessLayer from "../components/APIAccessLayer";

const APIAccess = () => (
  <MasterLayout>
    <PageHero
      title="API Keys"
      subtitle="Generate tokens and integrate WhatsApp sending into your apps."
      badge={{ icon: "mdi:key-variant", label: "Developer" }}
    />
    <APIAccessLayer />
  </MasterLayout>
);

export default APIAccess;
